import { useContext, useEffect, useRef, useState } from "react";
import { DarkModeContext } from "../context/DarkModeContext";
import { MdLightMode, MdDarkMode } from "react-icons/md";
import { RiMoonClearFill, RiMoonFill, RiSunFill } from "react-icons/ri";

const ModeButton = () => {
  const { darkMode } = useContext(DarkModeContext);
  const { dispatch } = useContext(DarkModeContext);
  const modeButtonRef = useRef(null);
  useEffect(() => {
    const modeButtonElement = modeButtonRef.current;

    // Ensure modeButtonElement is not null before adding the event listener
    if (modeButtonElement) {
      const handleWheel = (event) => {
        if (event.ctrlKey) {
          event.preventDefault(); // This prevents the zooming behavior
        }
      };

      // Add the wheel event listener without the passive option
      modeButtonElement.addEventListener("wheel", handleWheel, {
        passive: false,
      });

      // Clean up the event listener when the component unmounts
      return () => {
        modeButtonElement.removeEventListener("wheel", handleWheel);
      };
    }
  }, []);
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    if (isDark) {
      document.getElementsByTagName("body")[0].classList.add("dark");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("dark");
    }
  }, [isDark]);
  return (
    <button
      ref={modeButtonRef}
      className={`p-1 rounded-full shadow-lg transition-all duration-300 ${
        isDark
          ? "bg-gray-700 text-white hover:bg-gray-600 hover:shadow-xl"
          : "bg-gray-200 text-gray-700 hover:bg-gray-300 hover:shadow-xl"
      }`}
      onClick={() => {
        dispatch({ type: "TOGGLE" });
        setIsDark(!isDark);
      }}
    >
      {isDark ? <RiMoonClearFill size={25} /> : <RiSunFill size={25} />}
    </button>
  );
};

export default ModeButton;
